<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentPlanId"
            @click="currentPlanId = $event.id"
        >
            <template v-slot:table-actions>
                <button type="button" class="btn btn-primary btn-collapse-md" @click.prevent="currentPlanId = null; addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i>
                    <span class="btn-text">Add Plan</span>
                </button>
            </template>
        </fast-table>

        <sidebar
            v-if="currentPlan"
            :plan="currentPlan"
            @updated="onUpdate($event)"
            @deleted="currentPlanId = null; getData()"
            @close="currentPlanId = null"
        />
        <plan-modal v-if="addModalOpen" @updated="getData()" @close="addModalOpen = false" />
    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import PlanModal from './components/PlanModal'
import Sidebar from './components/PlanSidebar'

export default {
    components: {FastTable, Page, Sidebar, PlanModal, },
    computed: {
        currentPlan() {
            return this.plans.find(p => p.id == this.currentPlanId)
        },
        tableData() {
            const sectionData = this.plans.map(p => ({
                id: p.id,
                isActive: p.id == this.currentPlanId,
                object: p,
                cells: [
                    p.name,
                    p.state_pretty || '-',
                    p.plan_type_pretty,
                    p.method_pretty,
                    p.tiers.length,
                    p.client_count,
                ],
            }))
            return [sectionData]
        },
    },
    data() {
        return {
            plans: [],
            dataLoaded: false,
            currentPlanId: null,
            addModalOpen: false,

            headers: [
                {label: 'Plan', classes: '', isSearchable: true, defaultSort: true},
                {label: 'State', classes: 'cw-8', isFilterable: true},
                {label: 'Type', classes: 'cw-6', isFilterable: true},
                {label: 'Method', classes: 'cw-10', isFilterable: true},
                {label: 'Premium Tiers', classes: 'cw-6'},
                {label: 'Clients', classes: 'cw-4'},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Accruals / Plans')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/accruals/plans`).then(plans => {
                this.plans = plans
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate(plan) {
            const existing = this.plans.find(p => p.id == plan.id)
            if (existing) {
                Object.assign(existing, plan)
            }
            else { this.getData() }
        },
    },
}
</script>
